import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { messageReducer } from "./message/messageReducer";
import { systemReducer } from "./system/systemReducer";
import {passportReducer} from "./passport/reducer"
import { onBoardingReducer } from "./onBoarding/onBoardingReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  message: messageReducer,
  system: systemReducer,
  passport: passportReducer,
  onBoarding: onBoardingReducer,
});
